import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './App.css' 
import './Utils.css'
import './Colors.css'

createApp(App).use(router).mount('#app')
